



































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { TicketSettingModule } from '@/store/modules/ticketsetting';
import { IPlanSummaryData } from '@/api/types';
import {
  IListTicketSettingsRequest,
  IListPlansRequest,
  listPlans,
} from '@/api/tickets';
import {
  formatApiError,
  translateComponentResource,
  compareString,
} from '@/utils/index';
import { planToText } from '@/utils/tickets';

type ItemType = {
  text: string;
  value: string;
};

@Component({
  name: 'TicketSettingListSearch',
})
export default class TicketSettingListSearch extends Vue {
  @Prop({ required: true }) plans!: IPlanSummaryData[];
  public static readonly ticketSettingSearchEvent = 'ticket-setting-search';
  private valid = false;
  private openPanels = [0];
  private plansByPlanId: Map<string, IPlanSummaryData> = new Map();
  private planId: string = '';
  private planItems: ItemType[] = [];
  private unitId: string = '';
  private unitItems: ItemType[] = [];

  get canShowUnit() {
    return !!this.planId;
  }

  get canSearch() {
    return this.valid;
  }

  created() {
    this.loadTicketSettingListSearchForm();
  }

  mounted() {
    this.fetchDataThenSearch();
  }

  private search() {
    const req: IListTicketSettingsRequest = {};
    if (this.planId) {
      req.planId = this.planId;

      if (this.unitId) {
        req.unitId = this.unitId;
      }
    }
    this.$emit(TicketSettingListSearch.ticketSettingSearchEvent, req);

    TicketSettingModule.SaveTicketSettingListSearchForm({
      planId: req.planId || null,
      unitId: req.unitId || null,
    });
  }

  private reset() {
    TicketSettingModule.ClearTicketSettingListSearchForm();
    (this.$refs.form as any).reset();
  }

  private loadTicketSettingListSearchForm() {
    this.planId = TicketSettingModule.ticketSettingListSearchForm.planId || '';
    this.unitId = TicketSettingModule.ticketSettingListSearchForm.unitId || '';
  }

  private async fetchDataThenSearch() {
    await this.fetchData();
    this.$nextTick(() => {
      if (this.canSearch) {
        this.search();
      }
    });
  }

  private async fetchData() {
    AppModule.StartProgress();
    this.loadPlans();
    this.loadPlanItems();
    this.loadUnitItems();
    AppModule.StopProgress();
  }

  private loadPlans() {
    this.plansByPlanId = new Map(this.plans.map(p => [p.planId, p]));
  }

  private loadPlanItems() {
    const planItems: ItemType[] = [];
    this.plansByPlanId.forEach(p => {
      planItems.push({
        text: planToText(this.$i18n, p),
        value: p.planId,
      });
    });
    this.planItems = planItems.sort((a, b) => compareString(a.text, b.text));
  }

  private loadUnitItems() {
    this.unitId = '';
    const unitItems: ItemType[] = [];
    if (this.planId) {
      this.plansByPlanId.get(this.planId)!.units.forEach(u => {
        unitItems.push({
          text: u.title,
          value: u.id,
        });
      });
    }
    this.unitItems = unitItems;
  }

  private translateComponentResource(resource: string) {
    return translateComponentResource(
      this.$i18n,
      this.$options.name as string,
      resource
    );
  }
}
